module.exports = __webpack_public_path__ + "static/img/25.3d66072.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/25.png
// module id = IPo/
// module chunks = 0